import { type FetchAclPartnerSamlLoginParams } from '@capsicum/common';
import { atom } from 'jotai';

type PartnerAPIDataAtomType = {
	organization_name?: string;
	origin_partner_api?: string;
};

export const partnerAPIDataAtom = atom<PartnerAPIDataAtomType | undefined>(undefined);
// TODO generated types includes sigAlg and it needs SigAlg to work
export const partnerAPILoginDataAtom = atom<(FetchAclPartnerSamlLoginParams & { SigAlg?: string }) | undefined>(
	undefined
);
